import { BaseContainerModel } from '../base-container.model';
import { bl_cms_website_schema_hdr_RowClass } from '../../dbschema/bl_cms_website_schema_hdr.model';

export class WebsiteSchemaContainerModel extends BaseContainerModel {
    bl_cms_website_schema_hdr: bl_cms_website_schema_hdr_RowClass = new bl_cms_website_schema_hdr_RowClass();
}
